module.exports = __webpack_public_path__ + "img/energy4.1b6a511b.png";